import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Section-Specific Inline Disclaimers — Updated 17 March 2026
 */

const DISCLAIMERS = {
  thematic: "Informational constructs — not managed portfolios or recommendations. Inclusion of any security is not a recommendation. Past performance ≠ future results.",

  crypto_scoring: "From Era's experimental macro model. Educational only, not recommendations. Crypto is extremely volatile — you can lose all capital.",

  news_intel: "News section removed.", // Kept for backwards compatibility

  equities_ta: "Charts and TA by TradingView. Era does not control or verify. Indicators may produce false signals. Not a trading recommendation. Educational only.",

  crypto_ta: "TA is educational only. Indicators can produce false/contradictory signals. Crypto extremely volatile. AI commentary may contain errors. Verify independently. Consult a professional.",

  commodities_ta: "TA is educational only. Historical patterns may not repeat. AI commentary may contain errors. Commodity prices influenced by unpredictable factors. DYOR.",

  ai_commentary: "🤖 AI-generated. May contain errors. Not financial advice. Verify independently.",

  sentiment_macro: "From third-party sources. May be delayed, incomplete, or inaccurate. Educational only.",

  watchlist: "Price data from third parties. May be delayed or inaccurate. Inclusion of any asset is not a recommendation by Era.",

  community: "User-generated. Era does not verify or endorse. No user content constitutes investment advice. Decisions based on user content are at your sole risk.",

  screener: "Via TradingView. Not controlled or verified by Era. Appearance of any asset is not a recommendation. Screener criteria may not reflect your circumstances. DYOR. Educational only.",
};

const InlineDisclaimer = ({ section }) => {
  const text = DISCLAIMERS[section];
  if (!text) return null;

  return (
    <div className="flex items-start space-x-2 p-3 bg-amber-50/80 border border-amber-200 rounded-lg mt-4">
      <AlertCircle className="w-3.5 h-3.5 text-amber-600 mt-0.5 flex-shrink-0" />
      <p className="text-xs text-amber-800 leading-relaxed">{text}</p>
    </div>
  );
};

export default InlineDisclaimer;
